import { Component, LoaderManager } from 'shimmer'

import {
  DirectionalLight,
  AmbientLight
} from 'three'

import { webGL } from '@/webGL/WebGL'
import { textureLib } from '@/webGL/TextureLib'

export class Environment extends Component {
  constructor (name, isPBR = false) {
    super()

    this.name = name
    this.isPBR = isPBR

    this.promise = this.load(name)
    this.animationClip = null

    this.setupLight()
  }

  async load (name) {
    if (this.isPBR) {
      await textureLib.promise
    }

    return LoaderManager.load(name, false, obj => {
      obj.material.envMap = textureLib.envMap
      obj.material.needsUpdate = true
    }).then(res => {
      this.animationClip = res[0].object.animations[0]
      this.object = res[0].object.scene
      this.add(this.object)
    })
  }

  setupLight () {
    if (!this.isPBR) { return }

    this.ambient = new AmbientLight(0xffffff, .3)
    this.add(this.ambient)

    this.directional = new DirectionalLight(0xffffff, 1)
    this.directional.position.set(-15, 15, 20)
    this.directional.lookAt(0, 0, 0)
    this.directional.castShadow = true
    this.directional.shadow.bias = -0.0004
    this.directional.shadow.camera.far = 70
    this.directional.shadow.camera.near = 0.001
    this.directional.shadow.mapSize.width = 1024
    this.directional.shadow.mapSize.height = 1024
    this.directional.shadow.camera.updateProjectionMatrix()
    this.add(this.directional)
  }
}